import React from 'react';
import { getColorByName } from '../../utils/common';
import { Tag } from 'antd';

const index = ({ text, color, style = {} }) => {
  const tagColor = color || getColorByName(text);
  return (
    <Tag color={tagColor} style={{ maxWidth: 'fit-content', ...style }}>
      {text}
    </Tag>
  );
};

export default index;
